/* eslint-disable @typescript-eslint/default-param-last */
import {
  END_INTERVIEW_FOR_ALL,
  GET_LIBRARY_PROBLEMS,
  LEAVE_INTERVIEW,
  MOVE_CANDIDATE_TO_LOBBY,
} from "../constants/ActionTypes";
import initialState from "../store/initialState";
import { IGetLibraryProblemType } from "../types/problems.types";

const libraryReducer = (
  state = initialState.library,
  action: IGetLibraryProblemType,
) => {
  switch (action.type) {
    case `${GET_LIBRARY_PROBLEMS}_SUCCESS`:
      return {
        ...state,
        problems: action.payload.results,
        meta: action.payload.meta,
      };
    case `${LEAVE_INTERVIEW}_SUCCESS`:
    case `${MOVE_CANDIDATE_TO_LOBBY}_SUCCESS`:
    case `${END_INTERVIEW_FOR_ALL}_SUCCESS`:
      return initialState.library;
    default:
      return state;
  }
};

export default libraryReducer;
